(() => {
  if (window.__CPX_UBEAUTY_PILOT__) return;

  const slot = document.getElementById('cpx-ubeauty-badge');
  if (!slot) return;

  window.__CPX_UBEAUTY_PILOT__ = true;

  const PRODUCT_HANDLE = slot.dataset.productHandle;
  const PRODUCT_ID = slot.dataset.productId;
  const STORE_DOMAIN = slot.dataset.storeDomain;
  const CURRENCY = slot.dataset.currency;
  const IS_QA = ['127.0.0.1', 'localhost'].includes(window.location.hostname) ||
    new URLSearchParams(window.location.search).get('cpx_qa') === '1';
  const HOLDOUT_RATIO = 0.5;
  const COLLECTOR_URL = 'https://cpx-signer-7siyawhroq-uc.a.run.app/collect';
  const SHEETS_URL = 'https://script.google.com/macros/s/AKfycbyR300AH2jFRywfHKj-7RQqgW7Lj-WqRQVGaii8PlOtHgBiaWrUSPj1Hj-9oaPEv_mb/exec';

  const creators = [
    {
      id: 'tina-chen-craig',
      active: true,
      handle: '@tinachencraig',
      aliases: ['tina', 'tinachencraig'],
      adTokens: ['tina', 'tinachencraig'],
      quote: 'You’re getting 6 of our bestsellers in one TSA-compatible routine, at an even better price.',
      image: slot.dataset.tinaImage,
      imageClass: ''
    },
    {
      id: 'maddie-messer',
      active: false,
      handle: '@sweetteawithmadi',
      aliases: ['maddie', 'maddi', 'maddiemesser', 'maddimesser', 'sweetteawithmadi'],
      adTokens: ['maddiemesser', 'maddimesser', 'sweetteawithmadi'],
      quote: 'This set is such a steal you guys. I love that you can try everything before buying the full size.',
      image: slot.dataset.maddieImage,
      imageClass: 'cpx-ubeauty-badge__image--maddie'
    }
  ];

  const params = new URLSearchParams(window.location.search);
  const qaReviewCreator = params.get('cpx_qa') === '1'
    ? { 'review-0': 'tina', 'review-2': 'maddie' }[params.get('cpx_uid') || ''] || ''
    : '';
  const normalize = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/^@+/, '')
    .replace(/[^a-z0-9]+/g, '');

  const explicitCreator = params.get('cpx_ch') || params.get('ch') || qaReviewCreator;
  const adName = params.get('utm_content') || params.get('fb_ad') || '';
  const campaignContext = {
    ad_name: adName,
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_term: params.get('utm_term') || '',
    utm_content: params.get('utm_content') || '',
    utm_site_source_name: params.get('utm_site_source_name') || '',
    utm_placement: params.get('utm_placement') || '',
    fb_campaign: params.get('fb_campaign') || '',
    fb_campaignid: params.get('fb_campaignid') || '',
    fb_adset: params.get('fb_adset') || '',
    fb_adsetid: params.get('fb_adsetid') || '',
    fb_ad: params.get('fb_ad') || '',
    fb_adid: params.get('fb_adid') || ''
  };
  const normalizedExplicit = normalize(explicitCreator);
  const adParts = String(adName || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  const creator = creators.find((candidate) => {
    if (!candidate.active) return false;
    if (normalizedExplicit && candidate.aliases.some((alias) => normalize(alias) === normalizedExplicit)) {
      return true;
    }
    return adParts.length > 0 && candidate.adTokens.some((token) => adParts.includes(normalize(token)));
  });

  if (!creator) return;

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  };

  const setCookie = (name, value, days) => {
    document.cookie = `${name}=${encodeURIComponent(value)};path=/;max-age=${days * 86400};SameSite=Lax`;
  };

  const randomId = (prefix) => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return `${prefix}-${window.crypto.randomUUID()}`;
    }
    return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  };

  const getVisitorId = () => {
    const supplied = params.get('cpx_uid') || params.get('uid') || '';
    let id = supplied || getCookie('cpx_uid') || localStorage.getItem('cpx_uid') || '';
    if (!id) id = randomId('visitor');
    localStorage.setItem('cpx_uid', id);
    sessionStorage.setItem('cpx_uid', id);
    setCookie('cpx_uid', id, 30);
    return id;
  };

  const getSessionId = () => {
    let id = sessionStorage.getItem('cpx_session_id') || '';
    if (!id) {
      id = randomId('session');
      sessionStorage.setItem('cpx_session_id', id);
    }
    return id;
  };

  const hashRatio = (value) => {
    let hash = 2166136261;
    for (let index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0) / 4294967296;
  };

  const bootstrap = window.__CPX_UBEAUTY_BOOTSTRAP__;
  const hasMatchingBootstrap = bootstrap && bootstrap.creatorId === creator.id;
  const visitorId = hasMatchingBootstrap ? bootstrap.visitorId : getVisitorId();
  const sessionId = getSessionId();
  const arm = hasMatchingBootstrap
    ? bootstrap.arm
    : hashRatio(`${visitorId}|${creator.id}|${PRODUCT_HANDLE}`) < HOLDOUT_RATIO
      ? 'holdout'
      : 'treatment';
  const recommendation = `Recommended by ${creator.handle}`;

  localStorage.setItem('cpx_creator', creator.handle);
  localStorage.setItem('cpx_product_handle', PRODUCT_HANDLE);
  sessionStorage.setItem('cpx_creator', creator.handle);
  window.__CPX_ARM__ = arm;
  window.__CPX_UBEAUTY_CONTEXT__ = {
    creator: creator.handle,
    creatorId: creator.id,
    productHandle: PRODUCT_HANDLE,
    arm,
    rights: 'ok'
  };

  const currentVariantId = () => {
    const field = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return field && field.value ? String(field.value) : '';
  };

  const sendEvent = (eventType, extra = {}) => {
    const payload = {
      event_id: randomId('web'),
      event_type: eventType,
      type: eventType,
      ts: new Date().toISOString(),
      session_id: sessionId,
      product_handle: PRODUCT_HANDLE,
      variant_id: currentVariantId(),
      creator: creator.handle,
      persona: creator.id,
      arm,
      rights: 'ok',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : CURRENCY,
      source: 'meta',
      store_domain: STORE_DOMAIN,
      schema_version: 1,
      app_version: 'ubeauty-pilot-1',
      environment: 'production',
      extra: Object.assign({}, campaignContext, {
        creator_id: creator.id,
        product_id: String(PRODUCT_ID)
      }, extra)
    };

    const body = JSON.stringify(payload);
    if (IS_QA) {
      window.__CPX_QA_EVENTS__ = window.__CPX_QA_EVENTS__ || [];
      window.__CPX_QA_EVENTS__.push(payload);
      return;
    }

    fetch(COLLECTOR_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true
    }).catch(() => {});

    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(SHEETS_URL, new Blob([body], { type: 'text/plain' }));
      } else {
        fetch(SHEETS_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain' },
          body,
          keepalive: true
        }).catch(() => {});
      }
    } catch (_) {}
  };

  const ensureProperty = (form, name, value) => {
    let field = form.querySelector(`[name="${name}"]`);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
  };

  const orderAttributionValue = (value) => String(value || '').trim().slice(0, 255);

  const enrichProductForm = () => {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;

    ensureProperty(form, 'properties[_cpx_creator]', creator.handle);
    ensureProperty(form, 'properties[_cpx_creator_id]', creator.id);
    ensureProperty(form, 'properties[_cpx_arm]', arm);
    ensureProperty(form, 'properties[_cpx_rights]', 'ok');
    ensureProperty(form, 'properties[_product_handle]', PRODUCT_HANDLE);
    ensureProperty(form, 'properties[_cpx_ad_name]', orderAttributionValue(campaignContext.ad_name));
    ensureProperty(form, 'properties[_cpx_utm_campaign]', orderAttributionValue(campaignContext.utm_campaign));
    if (arm === 'treatment') {
      ensureProperty(form, 'properties[Recommended by]', creator.handle);
      ensureProperty(form, 'properties[_cpx_creator_line]', recommendation);
    }
    return form;
  };

  const form = enrichProductForm();
  if (!form) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        cpx_creator: creator.handle,
        cpx_creator_id: creator.id,
        cpx_arm: arm,
        cpx_rights: 'ok',
        cpx_product_handle: PRODUCT_HANDLE,
        cpx_ad_name: orderAttributionValue(campaignContext.ad_name),
        cpx_utm_campaign: orderAttributionValue(campaignContext.utm_campaign)
      }
    }),
    keepalive: true
  }).catch(() => {});

  if (arm === 'treatment' && slot.dataset.cpxRendered !== '1') {
    const inner = document.createElement('div');
    inner.className = 'cpx-ubeauty-badge__inner';
    const imageWrap = document.createElement('div');
    imageWrap.className = `cpx-ubeauty-badge__image ${creator.imageClass}`.trim();
    const image = document.createElement('img');
    image.src = creator.image;
    image.alt = creator.handle;
    image.width = 160;
    image.height = 160;
    image.loading = 'eager';
    imageWrap.appendChild(image);

    const content = document.createElement('div');
    const label = document.createElement('p');
    label.className = 'cpx-ubeauty-badge__label';
    label.textContent = `★ ${recommendation}`;
    const quote = document.createElement('p');
    quote.className = 'cpx-ubeauty-badge__quote';
    quote.textContent = `"${creator.quote}"`;
    content.append(label, quote);
    inner.append(imageWrap, content);
    slot.replaceChildren(inner);
    slot.dataset.cpxRendered = '1';
    slot.hidden = false;
  }

  sendEvent('pdp_view', { signal: explicitCreator ? 'explicit_creator' : 'meta_ad_name' });

  let lastVariantId = currentVariantId();
  form.addEventListener('change', () => {
    const nextVariantId = currentVariantId();
    if (!nextVariantId || nextVariantId === lastVariantId) return;
    lastVariantId = nextVariantId;
    sendEvent('pdp_variant', { action: 'manual' });
  });

  const atcKey = `cpx_atc_sent:${sessionId}:${creator.id}:${PRODUCT_HANDLE}:${arm}`;
  const reportAddToCart = (reason) => {
    if (sessionStorage.getItem(atcKey) === '1') return;
    sessionStorage.setItem(atcKey, '1');
    sendEvent('add_to_cart', { reason });
  };

  const verifyCart = async () => {
    const drawerMatched = Array.from(document.querySelectorAll('.cpx-cart-creator')).some(
      (element) => element.textContent.trim() === recommendation
    );
    if (drawerMatched) {
      reportAddToCart('cart_drawer_verified');
      return;
    }

    try {
      const cartResponse = await fetch('/cart.js', { cache: 'no-store' });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const matched = (cart.items || []).some((item) =>
        item.handle === PRODUCT_HANDLE &&
        item.properties &&
        item.properties._cpx_creator === creator.handle
      );
      if (matched) reportAddToCart('cart_verified');
    } catch (_) {}
  };

  const scheduleCartVerification = () => {
    [400, 1200, 2500].forEach((delay) => window.setTimeout(verifyCart, delay));
  };

  form.addEventListener('submit', () => {
    enrichProductForm();
    scheduleCartVerification();
  }, true);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button');
    if (!button || !/add to cart/i.test(button.textContent || '')) return;
    if (!button.closest('.js-product-main, .js-product-details, #js-sticky-atc-app')) return;
    enrichProductForm();
    scheduleCartVerification();
  }, true);
})();
